module.exports = "https://cdn-shared.mathletics.com/teacher-modules/student-reports/23/assets/images/3974705b1bbc9dd3ac21653b4002d73f.svg";


//////////////////
// WEBPACK FOOTER
// ./components/certificates/components/certificate-confirmation-modal/assets/download-icon.svg
// module id = cQtF
// module chunks = 1